const css = `.sync-course-request label {
  color: rgba(64, 64, 65, 0.8392156863);
  font-weight: 300;
}
.sync-course-request .ant-select-multiple .ant-select-selection-item {
  border: solid 1px #131396;
  border-radius: 50px;
  background: #edeff5;
  color: #131396;
}
.sync-course-request .ant-select-multiple .ant-select-selection-overflow-item-rest .ant-select-selection-item {
  background: #3a3b3d;
  color: white;
}
.sync-course-request .ant-radio-inner,
.sync-course-request .ant-radio-wrapper:hover {
  border-color: #131396;
}
.sync-course-request .ant-radio-inner .ant-radio .ant-radio-inner,
.sync-course-request .ant-radio-wrapper:hover .ant-radio .ant-radio-inner {
  border-color: #131396;
}
.sync-course-request .ant-radio-input:focus + .ant-radio-inner {
  box-shadow: 0 0 0 3px #edeff5;
  border-color: #131396;
}
.sync-course-request .ant-radio-checked ::after {
  background-color: #131396;
}

.empty-checkbox {
  display: block;
  border: solid 0.5px #131396;
  height: 1rem;
  width: 1rem;
}

.ant-select-item {
  transition: none;
}

.ant-select-item-option-content,
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  color: #3a3b3d;
  font-weight: 300;
}
.ant-select-item-option-content .anticon-check-square,
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .anticon-check-square {
  color: #131396;
}
.ant-select-item-option-content .ant-select-item-option-state,
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
  color: black;
}

.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background: #edeff5;
}
.ant-select-item-option-active:not(.ant-select-item-option-disabled) .ant-select-item-option-content {
  background: #edeff5;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
